import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — the cantilever balcony: a concrete deck slab, 1 m wide and
// 0.8 m deep, with a matte-black railing (top rail at 1.0 m over glass
// panels) around the three open sides. The back edge (-Z) is open to meet
// a wall. Authored with the deck base at y=0; the consumer lifts it to the
// storey it serves.
const CONCRETE = "#9a9a94";
const BLACK = "#2e2e30";
const GLASS = "#9fc4d4";

const W = 1.0;
const D = 0.8;
const SLAB_H = 0.1;
const RAIL_Y = 1.0;
// Glass panels run from just above the slab to just under the top rail.
const GLASS_H = 0.78;
const GLASS_Y = SLAB_H + 0.06 + GLASS_H / 2;

export const balcony = defineModel({
  id: "balcony",
  batchId: "modern",
  name: "Balcony",
  tags: ["modern", "outdoor", "structure", "balcony"],
  summary: "A cantilever balcony with a glass and matte-black railing.",
  description:
    "The cantilever balcony of the Modern Living kit: a 1.0 x 0.8 m " +
    "concrete deck with a matte-black top rail at 1.0 m over glass panels " +
    "on the three open sides; the back (-Z) edge is open to meet a wall. " +
    "Deck base at y=0; the consumer lifts it to its storey.",
  tiles: { w: 1, h: 1 },
  footprint: 0.9,
  parts(): Part[] {
    return [
      // Deck slab.
      { geometry: new THREE.BoxGeometry(W, SLAB_H, D), color: CONCRETE, position: [0, SLAB_H / 2, 0] },
      // Top rails: front (+Z) and the two sides.
      { geometry: new THREE.BoxGeometry(W, 0.05, 0.05), color: BLACK, position: [0, RAIL_Y, D / 2 - 0.03] },
      { geometry: new THREE.BoxGeometry(0.05, 0.05, D), color: BLACK, position: [-W / 2 + 0.03, RAIL_Y, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.05, D), color: BLACK, position: [W / 2 - 0.03, RAIL_Y, 0] },
      // Glass panels under the rails.
      { geometry: new THREE.BoxGeometry(W - 0.1, GLASS_H, 0.03), color: GLASS,
        position: [0, GLASS_Y, D / 2 - 0.03] },
      { geometry: new THREE.BoxGeometry(0.03, GLASS_H, D - 0.08), color: GLASS,
        position: [-W / 2 + 0.03, GLASS_Y, 0] },
      { geometry: new THREE.BoxGeometry(0.03, GLASS_H, D - 0.08), color: GLASS,
        position: [W / 2 - 0.03, GLASS_Y, 0] },
    ];
  },
  animations: [],
});
